export const UPDATE_PUBLIC_INNOVATION_PROJECTS_STATE = 'updatePublicInnovationProjectsState'
export const GET_PUBLIC_INNOVATION_PROJECTS_URL = 'getPublicInnovationProjectsUrl'
